module.exports = __webpack_public_path__ + "static/img/101263.81d2cd0a.png";